import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-card"
}

import { computed } from "vue";
import YouTube from "vue3-youtube";
import type { QwikUCard, SmartContent } from '@/types';

type Props = {
  mysmartcard: QwikUCard;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'VideosPage',
  props: {
    mysmartcard: {}
  },
  setup(__props: any) {

const props = __props;

const videoContents = computed((): SmartContent[] => {
  if (!props.mysmartcard?.SmartContent) {
    return [];
  }

  return props.mysmartcard.SmartContent.filter(
    (content) => content.contentType === "videoContent"
  );
});

return (_ctx: any,_cache: any) => {
  return (videoContents.value.length && __props.mysmartcard)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "heading" }, [
          _createElementVNode("h2", null, [
            _createElementVNode("span", { class: "yellow" }, "My"),
            _createTextVNode(),
            _createElementVNode("span", { class: "black" }, "Videos")
          ])
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoContents.value, (video, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_unref(YouTube), {
              src: video.contentUrl,
              width: "100%",
              height: "100%"
            }, null, 8, ["src"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})